import React, { useState, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import { deleteData, getAllData } from "../../Utility/API";
import { Button } from "react-bootstrap";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import { AiOutlineEdit } from "react-icons/ai";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import { Delete } from "@mui/icons-material";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import Tooltip from "@mui/material/Tooltip";
import DeleteModel from "../../components/DeleteModel";
import CreateLottery from "./CreateLottery";
import LotteryTicketsModal from "./LotteryTicketsModal";
// Settle action is switched off for now - see the commented block below.
// import MuiButton from "@mui/material/Button";
import { tokens } from "../../theme";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const Lottery = () => {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [createOpen, setCreateOpen] = useState(false);
  const [editData, setEditData] = useState({});
  const [ticketsOpen, setTicketsOpen] = useState(false);
  const [selectedLottery, setSelectedLottery] = useState(null);
  const [rowDataToDelete, setRowDataToDelete] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchLotteryData();
  }, []);

  const fetchLotteryData = async () => {
    let url = `${endPoints.api.GET_ALL_LOTTERY}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response?.status === "success") {
          setRows(response.data || []);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const onClose = () => {
    setCreateOpen(false);
    fetchLotteryData();
  };

// Settle action switched off for now; restore by uncommenting this and the JSX below.
//   /** The draw time has passed but the scheduler never finished it - the admin can run it by hand. */
//   const needsSettlement = (row) =>
//     row.status !== "SETTLED" &&
//     row.drawTime &&
//     new Date(row.drawTime).getTime() <= Date.now();
// 
//   const SettleLottery = (id) => {
//     setIsLoading(true);
//     let url = `${endPoints.api.SETTLE_LOTTERY}/${id}`;
//     addData(url, {})
//       .then((response) => {
//         setIsLoading(false);
//         if (response.data.status === "success") {
//           SuccesToast("Lottery Settled Successfully.");
//           fetchLotteryData();
//         } else {
//           ErrorToast(response.data.message);
//         }
//       })
//       .catch((err) => {
//         console.log(err);
//         setIsLoading(false);
//         ErrorToast("Unable to settle this lottery.");
//       });
//   };

  const handleDelete = (row) => {
    setRowDataToDelete(row);
    setShowDeleteModal(true);
  };

  const deleteLottery = () => {
    const id = rowDataToDelete?.id;
    let url = `${endPoints.api.DELETE_LOTTERY}/${id}`;
    setIsLoading(true);
    deleteData(url)
      .then((response) => {
        setIsLoading(false);
        setShowDeleteModal(false);
        if (response?.data?.status === "success") {
          SuccesToast(response?.data?.message || "Lottery Deleted Successfully.");
          fetchLotteryData();
        } else {
          ErrorToast(response?.data?.message || "Unable to delete lottery.");
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
        setShowDeleteModal(false);
        ErrorToast("Unable to delete lottery.");
      });
  };

  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <DeleteModel
          showModal={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onDelete={deleteLottery}
        />
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div
                  className="col-md-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #444",
                  }}
                >
                  <h3
                    className="mb-2"
                    style={{ fontFamily: "ArticulatCF-Bold" }}
                  >
                    Lottery
                  </h3>
                  <Button
                    variant="primary"
                    className="mrglft10"
                    style={{ height: "fit-content" }}
                    onClick={() => {
                      setEditData({});
                      setCreateOpen(true);
                    }}
                  >
                    Add Lottery
                  </Button>
                </div>
              </div>

              <CreateLottery
                open={createOpen}
                onClose={onClose}
                editData={editData}
              />

              <LotteryTicketsModal
                open={ticketsOpen}
                onClose={() => setTicketsOpen(false)}
                lottery={selectedLottery}
              />

              <div className="container-fluid table-custom">
                <div className="row" style={{ padding: "5px 0px 20px 0px" }}>
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        aria-label="a dense table"
                        stickyHeader
                        sx={{ minWidth: 500 }}
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Name</TableCell>
                            <TableCell align="center">Ticket Price</TableCell>
                            <TableCell align="center">Multiplier</TableCell>
                            <TableCell align="center">Prize (SC)</TableCell>
                            <TableCell align="center">Tickets Sold</TableCell>
                            <TableCell align="center">Ball Range</TableCell>
                            <TableCell align="center">Balls to Pick</TableCell>
                            <TableCell align="center">Draw Time</TableCell>
                            <TableCell align="center">Winning Numbers</TableCell>
                            <TableCell align="center">Status</TableCell>
                            <TableCell align="center">Winners</TableCell>
                            <TableCell align="center">Buyers</TableCell>
                            <TableCell align="center">Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(rowsPerPage > 0
                            ? rows.slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                              )
                            : rows
                          ).map((row) => (
                            <TableRow
                              key={row.id}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell align="center">{row.name}</TableCell>
                              <TableCell align="center">
                                {row.ticketPrice != null ? `$${row.ticketPrice}` : "-"}
                              </TableCell>
                              <TableCell align="center">
                                {row.multiplier ? `${row.multiplier}x` : "-"}
                              </TableCell>
                              <TableCell align="center">
                                {row.prizeSc ?? "-"}
                              </TableCell>
                              <TableCell align="center">
                                {row.soldTickets ?? 0} /{" "}
                                {row.totalTickets > 0
                                  ? row.totalTickets
                                  : "Unlimited"}
                              </TableCell>
                              <TableCell align="center">
                                1-{row.maxNumber}
                              </TableCell>
                              <TableCell align="center">
                                {row.ballCount ?? 3}
                              </TableCell>
                              <TableCell align="center">
                                {row.drawTime
                                  ? new Date(row.drawTime).toLocaleString()
                                  : ""}
                              </TableCell>
                              <TableCell align="center">
                                {row.drawnNumbers?.length
                                  ? row.drawnNumbers.join(", ")
                                  : "-"}
                              </TableCell>
                              <TableCell align="center">
                                {row.status ||
                                  (row.isActive === 1 ? "OPEN" : "Inactive")}
                              </TableCell>
                              <TableCell align="center">
                                {row.winners ?? 0}
                              </TableCell>
                              <TableCell align="center">
                                <Tooltip title="View buyers & their picks">
                                  <span
                                    onClick={() => {
                                      setSelectedLottery(row);
                                      setTicketsOpen(true);
                                    }}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <PeopleAltIcon />
                                  </span>
                                </Tooltip>
                              </TableCell>
                              <TableCell align="center">
                                {/* Flex rather than a bootstrap .row: that class
                                    carries negative side margins, which pushed
                                    these controls outside the cell. */}
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: 1,
                                  }}
                                >
                                  <Tooltip title="Edit">
                                    <IconButton
                                      size="small"
                                      sx={{ color: tokens.textDim }}
                                      onClick={() => {
                                        setEditData(row);
                                        setCreateOpen(true);
                                      }}
                                    >
                                      <AiOutlineEdit size={18} />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title="Delete">
                                    <IconButton
                                      size="small"
                                      sx={{ color: tokens.textDim }}
                                      onClick={() => {
                                        handleDelete(row);
                                      }}
                                    >
                                      <Delete fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                  {/* Settle action switched off for now.
                                  {needsSettlement(row) && (
                                    <Tooltip title="Draw time has passed - settle this lottery now">
                                      <MuiButton
                                        size="small"
                                        variant="outlined"
                                        onClick={() => {
                                          SettleLottery(row.id);
                                        }}
                                        sx={{
                                          textTransform: "none",
                                          whiteSpace: "nowrap",
                                          color: tokens.secondary,
                                          borderColor: "rgba(35,214,160,0.4)",
                                        }}
                                      >
                                        Settle
                                      </MuiButton>
                                    </Tooltip>
                                  )}
                                  */}
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={13} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={13}
                              count={rows.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Lottery;
